import _typeof from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.typed.uint8-array.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import dayjs from 'dayjs';
import { decompressUint8Array } from 'utils/work/unpackResult';
import parseResult from 'utils/work/parseResult';
import WorkTimeoutError from 'utils/errors/http/WorkTimeoutError';
import WorkResponseError from 'utils/errors/http/WorkResponseError';
import { updateBackendStatus } from 'redux/actions/backendStatus';
var timeoutIds = {};

// getTimeoutDate returns the date resulting of adding 'timeout' seconds to
// current time.
var getTimeoutDate = function getTimeoutDate(timeout) {
  return dayjs().add(timeout, 's').toISOString();
};

// set a timeout and save its ID in the timeoutIds map
// if there was a timeout for the current ETag, clear it before reseting it
var setOrRefreshTimeout = function setOrRefreshTimeout(request, timeoutDuration, reject, ETag) {
  if (timeoutIds[ETag]) {
    clearTimeout(timeoutIds[ETag]);
  }

  // timeoutDate needs to be initialized outside the timeout callback
  // or it will be computed when the error is raised instead of (now)
  // when the timeout is set
  var timeoutDate = getTimeoutDate(timeoutDuration);
  timeoutIds[ETag] = setTimeout(function () {
    reject(new WorkTimeoutError(timeoutDuration, timeoutDate, request, ETag));
  }, timeoutDuration * 1000);
};
var getWorkerTimeout = function getWorkerTimeout(taskName, defaultTimeout) {
  switch (taskName) {
    case 'GetEmbedding':
    case 'ListGenes':
    case 'MarkerHeatmap':
    case 'GetNormalizedExpression':
      {
        return dayjs().add(1800, 's').toISOString();
      }
    default:
      {
        return dayjs().add(defaultTimeout, 's').toISOString();
      }
  }
};
var waitForWorkRequest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ETag, experimentId, request, timeout, dispatch) {
    var _yield$import, connectionPromise, io, workerTimeoutDate, timeoutPromise, responsePromise;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return import('utils/socketConnection');
          case 2:
            _yield$import = _context2.sent;
            connectionPromise = _yield$import.default;
            _context2.next = 6;
            return connectionPromise;
          case 6:
            io = _context2.sent;
            // for listGenes, markerHeatmap, & getEmbedding we set a long timeout for the worker
            // after that timeout the worker will skip those requests
            // meanwhile in the UI we set a shorter timeout. The UI will be prolonging this timeout
            // as long as it receives "heartbeats" from the worker because that means the worker is alive
            // and progresing.
            // this should be removed if we make each request run in a different worker
            workerTimeoutDate = getWorkerTimeout(request, timeout);
            timeoutPromise = new Promise(function (resolve, reject) {
              setOrRefreshTimeout(request, timeout, reject, ETag);

              // this experiment update is received whenever a worker finishes any work request
              // related to the current experiment. We extend the timeout because we know
              // the worker is alive and was working on another request of our experiment
              io.on("Heartbeat-".concat(experimentId), function (message) {
                var newTimeoutDate = getTimeoutDate(timeout);
                if (newTimeoutDate < workerTimeoutDate) {
                  setOrRefreshTimeout(request, timeout, reject, ETag);
                }
                var status = {
                  worker: {
                    statusCode: message.status_code,
                    userMessage: message.user_message
                  }
                };
                dispatch(updateBackendStatus(experimentId, status));
              });
            });
            responsePromise = new Promise(function (resolve, reject) {
              io.on("WorkResponse-".concat(ETag), /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                  var response, errorCode, userMessage, decompressedData;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!(_typeof(res) === 'object')) {
                            _context.next = 6;
                            break;
                          }
                          response = res.response;
                          if (!response.error) {
                            _context.next = 5;
                            break;
                          }
                          errorCode = response.errorCode, userMessage = response.userMessage;
                          return _context.abrupt("return", reject(new WorkResponseError(errorCode, userMessage, request)));
                        case 5:
                          return _context.abrupt("return", resolve({
                            signedUrl: response.signedUrl
                          }));
                        case 6:
                          _context.next = 8;
                          return decompressUint8Array(Uint8Array.from(Buffer.from(res, 'base64')));
                        case 8:
                          decompressedData = _context.sent;
                          return _context.abrupt("return", resolve({
                            data: parseResult(decompressedData)
                          }));
                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));
                return function (_x6) {
                  return _ref2.apply(this, arguments);
                };
              }());
            }); // TODO switch to using normal WorkRequest for v2 requests
            _context2.next = 12;
            return Promise.race([timeoutPromise, responsePromise]);
          case 12:
            return _context2.abrupt("return", _context2.sent);
          case 13:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function waitForWorkRequest(_x, _x2, _x3, _x4, _x5) {
    return _ref.apply(this, arguments);
  };
}();
export default waitForWorkRequest;